import Icon from '../components/Icon.vue'

Icon.register({"viadeo":{"width":1280,"height":1792,"paths":[{"d":"M1050 1106q0 215-147 374-148 161-378 161-232 0-378-161-147-159-147-374 0-147 68-270.5t189-196.5 268-73q96 0 182 31-32 62-39 126-66-28-143-28-167 0-280.5 123t-113.5 291q0 170 112.5 288.5t281.5 118.5 281-118.5 112-288.5q0-89-32-166 66-13 123-49 41 98 41 212zM846 917q0 192-79.5 345t-238.5 253l-14 1q-29 0-62-5 83-32 146.5-102.5t99.5-154.5 58.5-189 30-192.5 7.5-178.5q0-69-3-103 55 160 55 326zM791 589v2q-73-214-206-440 88 59 142.5 186.5t63.5 251.5zM1035 792q-83 0-160-75 218-120 290-247 19-37 21-56-42 94-139.5 166.5t-204.5 97.5q-35-54-35-113 0-37 17-79t43-68q46-44 157-74 59-16 106-58.5t74-100.5q74 105 74 253 0 109-24 170-32 77-88.5 130.5t-130.5 53.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/viadeo.js
// module id = vMfk
// module chunks = 1